import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavigationHeader from './NavigationHeader';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import TestimonialsSection from './TestimonialsSection';
import BlogSection from './BlogSection';
import FAQSection from './FAQSection';
import ContactSection from './ContactSection';
import MapSection from '../shared/MapSection';
import GMBFeedSection from '../shared/GMBFeedSection';
import TagsSection from '../shared/TagsSection';
import Footer from './Footer';
import { LocalBusinessSchema } from '../SchemaScript';
import extractSchemaData from '../../utils/extractSchemaData';

const TemplateContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#fcf9f0'
}));

const Template5 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessInfo,
    navigation,
    aboutUs,
    services,
    testimonials,
    blogs,
    faq,
    contactInfo,
    footer,
    location,
    gmbFeed
  } = templateData || {};

  const schemaData = extractSchemaData(templateData);

  return (
    <TemplateContainer>
      {schemaData && <LocalBusinessSchema business={schemaData} />}
      <NavigationHeader businessInfo={businessInfo} navigation={navigation} />
      <HeroSection businessInfo={businessInfo} />
      <AboutSection aboutUs={aboutUs} />
      <ServicesSection services={services} />
      <TestimonialsSection testimonials={testimonials} />
      <MapSection location={location} />
      <GMBFeedSection gmbFeed={gmbFeed} />
      <TagsSection
        businessInfo={businessInfo}
        services={services}
        contactInfo={contactInfo}
      />
      <BlogSection blogs={blogs} />
      <FAQSection faq={faq} />
      <ContactSection contactInfo={contactInfo} footer={footer} />
      <TagsSection 
        businessInfo={businessInfo}
        services={services}
        contactInfo={contactInfo}
      />
      <Footer footer={footer} />
    </TemplateContainer>
  );
};

export default Template5;